export const blockIconsToggleToggleOff = (
	<span className='material-symbols-outlined'>toggle_off</span>
);
